import defaultValues from './origin-defaults';

/**
 *
 */


export default function origin(input) {
  var _ref = input || {},
      originData = _ref.origin;

  return originData;
}

export var defaultValue = defaultValues;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@spt-tracking/pulse-event-builders/dist/ejs/origin.js
// module id = 529
// module chunks = 0